export interface EventBus {
  events: Record<string, Array<(...args: any[]) => void>>;
  on(name: string, callback: (...args: any[]) => void): void;
  off(name: string): void;
  trigger(name: string, ...args: any[]): void;
}

const bus: EventBus = {
  events: {} as Record<string, Array<(...args: any[]) => void>>,

  on(name: string, callback: (...args: any[]) => void): void {
    if (!this.events[name]) {
      this.events[name] = [];
    }
    this.events[name].push(callback);
  },

  off(name: string): void {
    delete this.events[name];
  },

  trigger(name: string, ...args: any[]): void {
    if (this.events[name]) {
      this.events[name].forEach((cb) => cb(...args));
    }
  },
};

export default bus;
